export type SessionWarningEvent = CustomEvent<{
  secondsRemaining: number;
}>;

export type SessionEventType =
  | "TOKEN_REFRESHED"
  | "SESSION_EXTENDED"
  | "LOGOUT";

export type SessionBroadcastMessage = {
  type: SessionEventType;
  timestamp?: number;
};

export enum SessionStatus {
  ACTIVE = "ACTIVE",
  WARNING = "WARNING",
  EXPIRED = "EXPIRED",
}

export type SessionConfig = {
  warningThreshold: number;
  enableMultiTabSync: boolean;
};
